import dynamic from 'next/dynamic';

import { BlockLoadingSpinner } from 'components/LoadingSpinner';

import type { Props } from './AccountJulaProUserDetails';

const AccountJulaProUserDetailsSuspense = dynamic(
	() => import('./AccountJulaProUserDetails'),
	{ loading: () => <BlockLoadingSpinner /> },
);

export default function DynamicAccountJulaProUserDetails(props: Props) {
	return <AccountJulaProUserDetailsSuspense {...props} />;
}
DynamicAccountJulaProUserDetails.displayName =
	'DynamicAccountJulaProUserDetails';
